import { Component, OnInit, Output, EventEmitter, Renderer2, AfterViewInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { BrowserModule, DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { faMessage } from "@fortawesome/free-solid-svg-icons";
declare var google: any;
declare var OverlappingMarkerSpiderfier: any;
//https://developers.google.com/maps/documentation/javascript/examples/advanced-markers-html-simple
//https://developers.google.com/maps/documentation/javascript/examples/marker-labels
//https://developers.google.com/maps/documentation/javascript/custom-markers
//https://developers.google.com/maps/documentation/javascript/examples/marker-modern
//https://www.npmjs.com/package/@fortawesome/free-solid-svg-icons
//https://www.npmjs.com/package/fontawesome-markers
//https://www.w3schools.com/graphics/svg_intro.asp

//https://levelup.gitconnected.com/how-to-create-custom-html-markers-on-google-maps-9ff21be90e4b
//https://spatialized.io/advanced-google-maps-markers-definitive-guide-94c5a070615e436ab0a255b9f5100a88#9e0ed97c390a48d7ba52e5107565fb34

@Component({
  selector: 'app-advanced-markers',
  templateUrl: './advanced-markers.component.html',
  styleUrls: ['./advanced-markers.component.scss']
})
export class AdvancedMarkersComponent implements OnInit, AfterViewInit {
  rsltType: string = "Advanced Google Maps";
  title: string = "Google Maps";
  staticScreen = false; //true;

  baseUrl: string;
  url: string;

  ////lat: 40.4230, lng: -98.7372 -- USA
  lat = 40.4230;//12.9264;// india
  lng = -98.7372;//77.6012;//india

  @Output() childTitleEvent = new EventEmitter();

  map: any;
  optionsOMS = {
    //nearbyDistance: 100,
    legWeight: 2,
    markersWontMove: true,
    markersWontHide: true,
    keepSpiderfied: true,
    // spiderfyDistanceMultiplier:1.5,
    //circleSpiralSwitchover: 90,
    //spiralFootSeparation: 80,
    // spiralLengthStart :51,
    // spiralLengthFactor: 54,
    //spiderfiedZIndex :1,
    spiderfiedShadowColor: false,
    //unspiderfyFunction: function () { }
  };

  Markers_30000 = [];
  constructor(@Inject(DOCUMENT) private document: Document, private renderer2: Renderer2, private _Activatedroute: ActivatedRoute, private _router: Router, private http: HttpClient, private sanitizer: DomSanitizer, private elRef: ElementRef) {
    this.baseUrl = environment.urlAddress + '/api/';
  }

  ngOnInit() {
    setTimeout(() => {
      //this.JSInitialization();
      this.Initialize();
    }, 6000);
  }
  intersectionObserver:any;
  ngAfterViewInit() {
    this.GetSystemConfig();
    //https://stackoverflow.com/questions/70281750/easy-angular-way-to-detect-if-element-is-in-viewport-on-scroll
    this.intersectionObserver = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add("drop");
          this.intersectionObserver.unobserve(entry.target);
        }
      }
    });
  }

  //https://jsfiddle.net/gh/get/library/pure/googlemaps/js-samples/tree/master/dist/samples/advanced-markers-animation/jsfiddle
  getRandomPosition(map) {
  const bounds = map.getBounds();
  const minLat = bounds.getSouthWest().lat();
  const minLng = bounds.getSouthWest().lng();
  const maxLat = bounds.getNorthEast().lat();
  const maxLng = bounds.getNorthEast().lng();
  const latRange = maxLat - minLat;
  // Note: longitude can span from a positive longitude in the west to a
  // negative one in the east. e.g. 150lng (150E) <-> -30lng (30W) is a large
  // span that covers the whole USA.
  let lngRange = maxLng - minLng;

  if (maxLng < minLng) {
    lngRange += 360;
  }
  return {
    lat: minLat + Math.random() * latRange,
    lng: minLng + Math.random() * lngRange,
  };
}



async Initialize() {
  // Request needed libraries.
  const { Map } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
  const position = { lat: 39.045753, lng: -76.641273};//{ lat: 37.4242011827985, lng: -122.09242296450893 };
  const map = new Map(document.getElementById("map"), {
    zoom: 10,
    center: position,
    mapId: "4504f8b37365c3d0",
  });

  //var newmarker = this.Markers_30000.map(x => ({ lat: x.lat_num, lng: x.lng_num, iconurl: x.iconurl, itemID: x.itemID}));
  //console.log(newmarker)
  //console.log(this.Markers_30000.length)

  // Create 100 markers to animate.
  google.maps.event.addListenerOnce(map, "idle", () => {
    for (let i = 0; i < this.Markers_30000.length; i++) {
      this.createMarker(map, this.Markers_30000[i], AdvancedMarkerElement);
    }
  });

  // Add a button to reset the example.
  const controlDiv = document.createElement("div");
  const controlUI = document.createElement("button");

  controlUI.classList.add("ui-button");
  controlUI.innerText = "Reset the example";
  controlUI.addEventListener("click", () => {
    // Reset the example by reloading the map iframe.
    this.refreshMap();
  });
  controlDiv.appendChild(controlUI);
  map.controls[google.maps.ControlPosition.TOP_CENTER].push(controlDiv);
}

  createMarker(map, markerElem, AdvancedMarkerElement) {
    const advancedMarker = new AdvancedMarkerElement({
      position: { lat: markerElem.lat, lng: markerElem.lng },//this.getRandomPosition(map),
      map: map,
    });
    //const content = advancedMarker.content;

    //content.style.opacity = "0";
    //content.addEventListener("animationend", (event) => {
    //  content.classList.remove("drop");
    //  content.style.opacity = "1";
    //});

    //const time = 2 + Math.random(); // 2s delay for easy to see the animation

    //content.style.setProperty("--delay-time", time + "s");
    //if (this.intersectionObserver)
    //  this.intersectionObserver.observe(content);
  }

refreshMap() {
  // Refresh the map.
  const mapContainer = document.getElementById("mapContainer");
  const map = document.getElementById("map");

  map.remove();

  const mapDiv = document.createElement("div");

  mapDiv.id = "map";
  mapContainer.appendChild(mapDiv);
  this.Initialize();
}

  JSInitialization() {
    //// Request needed libraries.
    //const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    //const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

    const map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
      center: { lat: 37.42, lng: -122.1 },
      zoom: 14,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      //mapId: '4504f8b37365c3d0',
    });

    const priceTag = document.createElement('div');
    priceTag.className = 'price-tag';
    priceTag.textContent = '$2.5M';

    //const oms = new OverlappingMarkerSpiderfier(this.map, this.optionsOMS);

    ////const marker = new google.maps.Marker({
    //const marker = new google.maps.marker.AdvancedMarkerElement({
    //  map,
    //  position: { lat: 37.42, lng: -122.1 },
    //  content: priceTag,
    //});


    //const priceTag1 = document.createElement("div");

    //priceTag1.className = "pin2";
    //priceTag1.textContent = "Q";
    //const marker1 = new google.maps.marker.AdvancedMarkerElement({
    //  map,
    //  position: { lat: 37.42, lng: -122.1 },
    //  content: priceTag1,
    //});


    // use a FontAwesome svg
    const marker = new google.maps.Marker({
      position: { lat: 37.42, lng: -122.1 },
      map,
      icon: {
        path: faMessage.icon[4] as string,
        fillColor: "#0000ff",
        fillOpacity: 1,
        anchor: new google.maps.Point(
          faMessage.icon[0] / 2, // width
          faMessage.icon[1] // height
        ),
        strokeWeight: 1,
        strokeColor: "#ffffff",
        scale: 0.075,
      },
      title: "FontAwesome SVG Marker",
    });

    // use a Material Icon as font
    const marker1 = new google.maps.Marker({
      position: { lat: 36.6163, lng: -100.6 },
      map,
      label: {
        text: "\ue0ca", // codepoint - chat bubble from https://fonts.google.com/icons
        fontFamily: "Material Icons",
        color: "#ffffff",
        fontSize: "18px",
      },
      title: "Material Icon Font Marker",
    });



    const svgMarker = {
      path: "M416,0H96C42.969,0,0,42.969,0,96v160c0,53.031,42.969,96,96,96h63.984L256,512l96-160h64c53.031,0,96-42.969,96-96V96 C512,42.969,469.031,0,416,0z",
      fillColor: "blue",
      fillOpacity: 0.6,
      strokeWeight: 0,
      rotation: 0,
      scale: 0.1,
      //scaledSize: new google.maps.Size(5, 5),
      anchor: new google.maps.Point(0, 20),
      width: 24,
      height: 24,
    };

    const marker2 = new google.maps.Marker({
      position: map.getCenter(),
      icon: svgMarker,
      map: map,
    });


    //oms.addMarker(marker);//spiderfy
    //oms.keepSpiderfied = true;
  }


  scriptMapJS: any;
  scriptCallBack: any;
  loadScript(url) {
    this.scriptCallBack = this.renderer2.createElement('script');
    this.scriptCallBack.type = 'text/javascript';
    this.scriptCallBack.text = `
            function initMap() {
                 console.log('init map advanced')
            }
        `;
    this.renderer2.appendChild(this.document.body, this.scriptCallBack);

    return new Promise((resolve, reject) => {
      this.scriptMapJS = this.renderer2.createElement('script');
      this.scriptMapJS.type = 'text/javascript';
      this.scriptMapJS.src = url;
      this.scriptMapJS.text = ``;
      this.scriptMapJS.async = true;
      this.scriptMapJS.defer = true;
      this.scriptMapJS.onload = resolve;
      this.scriptMapJS.onerror = reject;
      this.renderer2.appendChild(this.document.body, this.scriptMapJS);
    })
  }
  GetSystemConfig() {
    this.url = this.baseUrl + 'UserAndSytemConfig/GetUserSystemConfiguration';
    let GoogleMapsAPIKey = "";
    this.GetConfigurations_Service().subscribe((res: any) => {
      //debugger;
      let rows: any[] = JSON.parse(res) as any[];
      GoogleMapsAPIKey = rows["GoogleMapsAPIKey"];
      if (GoogleMapsAPIKey == "") {
        if (confirm("API Key not set yet. Redirecting to setting page... Do you want to continue?")) {
          this._router.navigate([{ outlets: { filterPopup: null, configPopup: ['configuration', 'UserSetting', '1', 'false'] } }]);//splitting 'configuration/UserSetting' as / converting in %2f in URL
        }
      }
      else {
        let foundScriptElem = false;
        var c = document.getElementsByTagName('script');
        for (var x = 0; x < c.length; x++) {
          if (document.body.innerHTML.indexOf('initMap') != -1) {
            foundScriptElem = true;//c[x].parentElement.removeChild(c[x]);
            break;
          }
        }
        if (!foundScriptElem) {
          //const url = 'https://maps.googleapis.com/maps/api/js?key=' + GoogleMapsAPIKey + '&libraries=places&libraries=geometry&callback=initMap';

          ////// below code used for AdvacneMarker
          const url = 'https://maps.googleapis.com/maps/api/js?key=' + GoogleMapsAPIKey + '&libraries=places&libraries=geometry&libraries=marker&callback=initMap';
          this.loadScript(url);
        }
      }
    });
  }
  GetConfigurations_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);

  }

  parentEvent(title) {
    this.title = title;
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }
}

